module.exports = __webpack_public_path__ + "img/23.37a95ef3.jpg";